import React from 'react';

import './styles/ourValues.scss';

const OurValues = () => (
  <div className="our-values">
    <div className="container-inner">
      <div className="our-values__title">
        <span>The time has come to&nbsp;do&nbsp;deep tech.</span>
        <h2>Our values</h2>
      </div>
      <div className="our-values__list">
        <ul>
          <li>
            <p>Radical deep tech innovations are the ticket to&nbsp;sustainable human flourishing</p>
          </li>
          <li>
            <p>Fearlessness is&nbsp;the fuel that keeps&nbsp;us going</p>
          </li>
          <li>
            <p>We&nbsp;are united behind a&nbsp;common purpose</p>
          </li>
          <li>
            <p>Facts over bias,<br />every time</p>
          </li>
        </ul>
      </div>
    </div>
  </div>
)

export default OurValues;
